import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-signout-oidc',
    templateUrl: './signout-oidc.component.html',
    styleUrls: ['./signout-oidc.component.css']
})
export class SignoutOidcComponent { }

// Keep this class here to prevent console errors
